import script from "./hscodeDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./hscodeDetail.vue?vue&type=script&setup=true&lang=js"

import "./hscodeDetail.vue?vue&type=style&index=0&id=cc7078ae&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc7078ae"]])

export default __exports__